import { useCallback, useEffect, useRef, useState } from 'react';
import { mcpConnectAction, parseMcpSnapshot } from './desktopMcp.js';
export function useDesktopMcp(enabled) {
    const [snapshot, setSnapshot] = useState(null);
    const [state, setState] = useState('loading');
    const [refreshing, setRefreshing] = useState(false);
    const [connecting, setConnecting] = useState(null);
    const connectTimeout = useRef(undefined);
    const [now, setNow] = useState(Date.now());
    const timeout = useRef(undefined);
    const refresh = useCallback(() => {
        if (!enabled)
            return;
        setRefreshing(true);
        clearTimeout(timeout.current);
        window.dispatchEvent(new CustomEvent('gyro:mcp-refresh'));
        timeout.current = setTimeout(() => setRefreshing(false), 45_000);
    }, [enabled]);
    // One message shape for both dialogs: the desktop app reads the row's own state (Windows consent, or a changed
    // project configuration) and shows the matching native dialog; the page never says which, and cannot grant either.
    const connect = useCallback((name) => {
        if (!enabled || connecting || !snapshot?.servers.some(server => server.name === name && mcpConnectAction(server) !== null))
            return;
        setConnecting(name);
        clearTimeout(connectTimeout.current);
        window.dispatchEvent(new CustomEvent('gyro:mcp-connect', { detail: { name } }));
        connectTimeout.current = setTimeout(() => setConnecting(null), 120_000);
    }, [enabled, connecting, snapshot]);
    useEffect(() => {
        if (!enabled)
            return;
        const available = () => { clearTimeout(initial); setState(current => current === 'ready' ? current : 'loading'); };
        const receive = (event) => {
            const next = parseMcpSnapshot(event.detail);
            if (!next)
                return;
            setSnapshot(previous => previous && previous.updatedAt > next.updatedAt ? previous : next);
            setState('ready');
            setRefreshing(false);
            clearTimeout(timeout.current);
            setNow(Date.now());
        };
        const consentResult = () => { setConnecting(null); clearTimeout(connectTimeout.current); };
        window.addEventListener('gyro:mcp-consent-result', consentResult);
        window.addEventListener('gyro:mcp-snapshot', receive);
        const initial = setTimeout(() => setState(current => current === 'loading' ? 'unavailable' : current), 8000);
        window.addEventListener('gyro:mcp-available', available);
        const tick = setInterval(() => setNow(Date.now()), 60_000);
        window.dispatchEvent(new CustomEvent('gyro:mcp-ready'));
        return () => {
            window.removeEventListener('gyro:mcp-snapshot', receive);
            window.removeEventListener('gyro:mcp-consent-result', consentResult);
            clearTimeout(connectTimeout.current);
            window.removeEventListener('gyro:mcp-available', available);
            clearTimeout(initial);
            clearTimeout(timeout.current);
            clearInterval(tick);
        };
    }, [enabled]);
    return { snapshot, state, refreshing, refresh, connect, connecting, now };
}
//# sourceMappingURL=useDesktopMcp.js.map